// Single source of truth for purchasable products.
// lookup_key MUST match the Stripe price lookup_key (see backend/scripts/setup_stripe.py).
// USD is what Stripe charges; MXN is a display-only reference (~18.5 MXN/USD).

export const PRODUCTS = {
  toolkit: {
    key: "toolkit",
    name: "The Debt Toolkit",
    type: "onetime",
    usd: "$149",
    mxn: "MXN 2,900",
    blurb: "Los modelos, checklists y plantillas que uso para preparar un fondeo institucional.",
    features: [
      "Modelo de cartera (lender) y de PyME en Excel",
      "Checklist de data room · 80 puntos",
      "Glosario de covenants en español",
      "Plantilla de term sheet anotada",
      "Video walkthrough de 40 min",
    ],
  },
  ebook_startups: {
    key: "ebook_startups", name: "Ebook · Deuda Startups", type: "onetime",
    usd: "$19", mxn: "MXN 349",
    blurb: "Cómo una startup arma su primera ronda — equity + su primera línea de deuda, sin regalar el 30% de la empresa.",
  },
  course_startups: {
    key: "course_startups", name: "Curso · Deuda Startups", type: "onetime",
    usd: "$149", mxn: "MXN 2,900",
    blurb: "El curso aplicado para levantar tu ronda y tu primera deuda como insider, de pre-seed a Serie A.",
  },
  cohort_startups: {
    key: "cohort_startups", name: "The Debt Program · Startups", type: "onetime",
    usd: "$540", mxn: "MXN 10,000", installmentKey: "cohort_startups_3x", installmentUsd: "$180",
    blurb: "Programa acompañado para armar tu ronda + tu primera línea de deuda, del diagnóstico al cierre.",
  },
  ebook_pymes: {
    key: "ebook_pymes", name: "Ebook · Deuda PyMEs", type: "onetime",
    usd: "$19", mxn: "MXN 349",
    blurb: "Cómo una PyME de habla hispana levanta capital de trabajo o crédito sin morir en el intento.",
  },
  ebook_lenders: {
    key: "ebook_lenders", name: "Ebook · Deuda Lenders", type: "onetime",
    usd: "$19", mxn: "MXN 349",
    blurb: "Estructura tu primer warehouse y prepara tu plataforma de crédito para fondeo institucional.",
  },
  ebook_fincorp: {
    key: "ebook_fincorp", name: "Ebook · FinCorp", type: "onetime",
    usd: "$19", mxn: "MXN 349",
    blurb: "M&A, bolsa, bonos, emisiones y reverse mergers en LATAM y USA, explicados por dentro.",
  },
  ebook_bundle: {
    key: "ebook_bundle", name: "Bundle · 3 Ebooks", type: "onetime",
    usd: "$39", mxn: "MXN 749",
    blurb: "Los tres ebooks (PyMEs · Lenders · FinCorp) con descuento.",
  },
  course_pymes: {
    key: "course_pymes", name: "Curso · Deuda PyMEs", type: "onetime",
    usd: "$149", mxn: "MXN 2,900",
    blurb: "El curso aplicado para conseguir capital de trabajo y crédito bancario para tu PyME.",
  },
  course_lenders: {
    key: "course_lenders", name: "Curso · Deuda Lenders", type: "onetime",
    usd: "$199", mxn: "MXN 3,900",
    blurb: "El paso a paso para estructurar un warehouse y cerrar tu primera línea institucional.",
  },
  course_fincorp: {
    key: "course_fincorp", name: "Curso · FinCorp", type: "onetime",
    usd: "$249", mxn: "MXN 4,900",
    blurb: "Corporate finance y capital markets aplicados: M&A, bonos, emisiones e IPO.",
  },
  cert_fincorp: {
    key: "cert_fincorp", name: "Certificación FinCorp", type: "onetime",
    usd: "$2,500", mxn: "MXN 49,000",
    blurb: "Certificación profesional en Corporate Finance & Capital Markets, avalada por IADA Anáhuac.",
  },
  ebook_intangibles: {
    key: "ebook_intangibles", name: "Ebook · Valuación de Intangibles", type: "onetime",
    usd: "$29", mxn: "MXN 549",
    blurb: "Cómo valuar tus activos intangibles —marca, IP, datos, contratos, cartera recurrente— para levantar deuda contra ellos.",
  },
  course_intangibles: {
    key: "course_intangibles", name: "Curso · Valuación de Intangibles", type: "onetime",
    usd: "$299", mxn: "MXN 5,900",
    blurb: "El método completo para valuar intangibles y convertirlos en colateral que un banco o fondo sí acepta como respaldo de una línea de crédito.",
    features: [
      "Los 6 métodos de valuación aplicados (con plantilla en Excel)",
      "Cómo se valúa cartera recurrente / ARR como colateral",
      "IP, marca y patentes: valuación y cómo se gravan",
      "De la valuación al borrowing base y el advance rate",
      "Memo de valuación y data room listos para el prestamista",
    ],
  },
  cohort_pymes: {
    key: "cohort_pymes", name: "The Debt Program · PyMEs", type: "onetime",
    usd: "$540", mxn: "MXN 10,000", installmentKey: "cohort_pymes_3x", installmentUsd: "$180",
    blurb: "Programa acompañado, del diagnóstico a tu solicitud lista para banco o fondo.",
  },
  cohort_lenders: {
    key: "cohort_lenders", name: "The Debt Program · Lenders / Instituciones", type: "onetime",
    usd: "$810", mxn: "MXN 15,000", installmentKey: "cohort_lenders_3x", installmentUsd: "$270",
    blurb: "Data room auditado, modelo de cartera, teaser, term sheet negociable y 10 fondos con apetito. Cierra con panel.",
  },
  cohort_intangibles: {
    key: "cohort_intangibles", name: "Diagnóstico de Intangibles · 1:1", type: "onetime",
    usd: "$405", mxn: "MXN 7,500",
    blurb: "Revisamos tus intangibles y armamos el caso de valuación y colateral para tu próximo levantamiento de deuda.",
  },
  consulting_1to1: {
    key: "consulting_1to1", name: "Capital Markets as a Service · 10h 1:1", type: "onetime",
    usd: "$1,620", mxn: "MXN 30,000", installmentKey: "consulting_1to1_3x", installmentUsd: "$540",
    blurb: "10 horas de consultoría 1:1 directo conmigo: diseñamos tu estructura de capital, negociamos tus term sheets y ejecutamos el fondeo hasta el desembolso.",
  },
  circle_monthly: {
    key: "circle_monthly", name: "The Debt Circle · Mensual", type: "subscription",
    interval: "mes", usd: "$79", mxn: "MXN 1,490",
  },
  circle_annual: {
    key: "circle_annual", name: "The Debt Circle · Anual", type: "subscription",
    interval: "año", usd: "$790", mxn: "MXN 14,900",
  },
  circle_founder: {
    key: "circle_founder", name: "The Debt Circle · Fundador", type: "subscription",
    interval: "mes", usd: "$49", mxn: "MXN 890",
  },
  teardown_pro_monthly: {
    key: "teardown_pro_monthly", name: "Teardown Pro", type: "subscription",
    interval: "mes", usd: "$29", mxn: "MXN 549",
  },
};

export const getProduct = (key) => PRODUCTS[key];
